import React, {useEffect, useState} from "react";
import {useIsMobile} from "../../../hooks/useIsMobile";
import ProfileEdit from "./ProfileEdit";
import ProfileEditMobile from "./ProfileEdit";
import {getPostCard, getProfileList} from "../../../api/index";
import { useLoading } from "../../controls/LoadingContext";

const ProfileEditContainer = () => {

    const isMobile = useIsMobile();
    const [profileList, setProfileList] = useState<any>([]);
    const [email, setEmail] = useState<any>([]);
    const { showLoading, hideLoading } = useLoading();

    useEffect(() => {

        const email = localStorage.getItem("email");

        if(email) {

            const getData = async () => {
                try {
                    showLoading();
                    const data = await getProfileList(email);
                    setProfileList(data);
                } catch (e) {
                    console.error("프로필 데이터 로드 실패:", e);
                } finally {
                    hideLoading();
                }

            };

            getData();
        }

    }, [])

    return(
        <>

            {isMobile ? <ProfileEditMobile profileList={profileList}/>: <ProfileEdit profileList={profileList}/>}

        </>
    )



}

export default ProfileEditContainer;
